import React, { useCallback, useEffect, useState } from 'react';

import { useIntl } from 'react-intl';

import { IStore } from '@rbi-ctg/store';
import useDialogModal from 'hooks/use-dialog-modal';
import { useRestaurantFzDetails } from 'state/loyalty/hooks/use-restaurant-fz-details';
import { useStoreContext } from 'state/store';

import { Container, Group, RestaurantDetailsStyle, StoreDetails } from './styled';
import { IRestaurantFzDetails } from './types';

const RestaurantDetailsModal: React.FC = () => {
  const { store } = useStoreContext();
  const { formatMessage } = useIntl();
  const { getFzDetailsForRestaurant } = useRestaurantFzDetails();
  const [restaurantDetails, setRestaurantDetails] = useState<IRestaurantFzDetails>();

  const [RestaurantDetailsDialog, openRestaurantDetails] = useDialogModal({
    modalAppearanceEventMessage: 'Restaurant Details',
  });

  const getFzDetails = useCallback(
    async (storeToCheck: IStore) => getFzDetailsForRestaurant(storeToCheck),
    [getFzDetailsForRestaurant]
  );

  useEffect(() => {
    async function queryDetails() {
      const response = await getFzDetails(store as IStore);
      setRestaurantDetails(response);
    }
    queryDetails();
  }, [getFzDetails, store]);

  return (
    <>
      <StoreDetails onClick={openRestaurantDetails} data-testid="see-store-details">
        {formatMessage({ id: 'seeFzStoreDetails' })}
      </StoreDetails>
      <RestaurantDetailsDialog
        className="restaurant-details-modal"
        heading=""
        buttonLabel={formatMessage({ id: 'close' })}
        body={
          <Container data-testid="restaurant-details-container">
            <Group>
              <div>
                Store ID: <strong>{store.number}</strong>
              </div>
              <div>
                Store Adress: <strong>{store.physicalAddress?.address1}</strong>
              </div>
              <div>
                Store ZIP Code: <strong>{store.physicalAddress?.postalCode}</strong>
              </div>
              <div>
                Store City: <strong>{store.physicalAddress?.city}</strong>
              </div>
            </Group>
            <Group>
              <div>
                FZ Address: <strong>{restaurantDetails?.fzAddress}</strong>
              </div>
              <div>
                FZ ZIP Code: <strong>{restaurantDetails?.fzZipCode}</strong>
              </div>
              <div>
                FZ City: <strong>{restaurantDetails?.fzCity}</strong>
              </div>
              <div>
                FZee Group: <strong>{restaurantDetails?.fzeeGroup}</strong>
              </div>
            </Group>
            <Group>
              <div>
                Authorized Representative:{' '}
                <strong>{restaurantDetails?.fzAuthorizedRepresentative} </strong>
              </div>
              <div>
                Email: <strong>{restaurantDetails?.fzEmail}</strong>
              </div>
              <div>
                Tel: <strong>{restaurantDetails?.fzTelephone}</strong>
              </div>
            </Group>
            <Group>
              <div>
                Registry Court: <strong>{restaurantDetails?.fzRegistryCourt}</strong>
              </div>
              <div>
                HRB: <strong>{restaurantDetails?.fzHrb}</strong>
              </div>
              <div>
                Ust.NR.: <strong>{restaurantDetails?.fzUstNr}</strong>
              </div>
            </Group>
          </Container>
        }
      />
      <RestaurantDetailsStyle />
    </>
  );
};

export default RestaurantDetailsModal;
